import { map } from 'rxjs/operators';

export const negate = map((v) => !v);
